<template>
  <div class="transaction-income">
    <div class="modal-header add-income-header">
      <h2>Dodaj uplatu</h2>
      <span rel="popover" data-placement="left">
        <i
          class="fas fa-info-circle expense-tooltip"
          title="Ukoliko ne izaberete stanara uplata će se voditi kao uplata u zajednicu i neće biti vezana ni za jednog stanara."
        ></i>
      </span>
    </div>
    <div class="body">
      <div class="input-wrapper">
        <label for="issue-date" class="desc">Uplatilac</label>
        <div class="radio-wrapper">
          <label class="container">
            Stanar
            <input type="radio" name="radio" value="member" v-model="payerOption" />
            <span class="checkmark"></span>
          </label>
          <label class="container">
            Drugi
            <input type="radio" name="radio" value="other" v-model="payerOption" />
            <span class="checkmark"></span>
          </label>
        </div>
        <div class="user--mod payer-member relative" v-if="payerOption === 'member'">
          <model-select
            ref="member"
            :options="options"
            v-model="selectedMember"
            placeholder="
            Stanar"
            @input="onChange"
          ></model-select>
        </div>
        <div class="amount--mod payer-member relative" v-if="payerOption === 'other'">
          <input
            type="text"
            class="form-control form-control-lg input--amount"
            placeholder="Unesite uplatioca"
            v-model.lazy="payerName"
            v-on:keyup.enter="addIncome"
            @focus="$event.target.select()"
          />
        </div>
        <div class="amount--mod relative">
          <input
            type="text"
            class="form-control form-control-lg input--amount"
            ref="amountInput"
            placeholder=" "
            v-model.lazy="incomeAmount"
            v-money="{}"
            v-on:keyup.enter="addIncome"
            @focus="$event.target.select()"
          />
          <span class="input-span input-span--amount">Iznos</span>
        </div>

        <div class="amount--mod relative">
          <label for="issue-date" class="desc">Opis</label>

          <input
            type="text"
            class="form-control form-control-lg input--amount"
            placeholder="Opis uplate"
            v-model.lazy="incomeDescription"
            v-on:keyup.enter="addIncome"
            @focus="$event.target.select()"
          />
        </div>

        <div class="date--mod">
          <label for="issue-date" class="desc">Datum izdavanja</label>
          <datetime
            ref="datetime"
            type="date"
            @input="handleDatetimeInput"
            :phrases="{
                  ok: 'U redu',
                  cancel: 'Otkaži'
                }"
            format="dd/MM/yyyy"
            v-model="issueDate"
          ></datetime>
          <div
            class="form-control form-control-lg datetime-mask"
            type="text"
            id="issue-date"
            @click="handleDatetimeClick"
          >
            {{ issueDate | formatDate }}
            <i class="far fa-calendar-alt calendar--mod"></i>
          </div>
        </div>
        <button class="btn btn-primary btn--add" @click="addIncome">Dodaj</button>
        <div class="member-info">
          <div class="member-info-title">Podaci o izabranom korisniku</div>
          <div class="column-wrapper member-information">
            <div class="column">
              <div>
                <small>Ime i prezime</small>
                <h6>{{getSelectedUser.full_name}}</h6>
              </div>
              <div>
                <small>Stanje</small>
                <h6>{{getSelectedUser.balance | addSeparator}}</h6>
              </div>
            </div>
            <div class="column">
              <div>
                <small>Opis</small>
                <h6>{{getSelectedUser.div_description}}</h6>
              </div>
              <div>
                <small>Poziv na broj</small>
                <h6>{{getSelectedUser.id}}</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="data-wrapper">
        <div class="members-table">
          <finances-mini-table
            :columns="columns"
            :data="data"
            @remove="removeMember"
            :showTrashCan="true"
          ></finances-mini-table>
        </div>
        <div class="total">UKUPNO: {{ total | addSeparator }}</div>
      </div>
    </div>
    <hr />
    <div class="footer add-income">
      <div class="error">
        <transition enter-active-class="animated shake">
          <p class="err-msg" v-if="errorOccurred">{{ errorMessage }}</p>
        </transition>
      </div>
      <div class="buttons">
        <button type="submit" class="btn btn-danger btn--mod" @click="closeModal">Otkaži</button>
        <button type="submit" class="btn btn-primary btn--mod" :disabled="loading" @click="save">
          <p v-if="!loading">Sačuvaj</p>
          <spinner :size="20" line-fg-color="#00796b" v-if="loading" />
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapActions, mapState } from 'vuex';
import { ModelSelect } from 'vue-search-select';
import { addSeparatorMixin, formatDateMixin } from '@/mixins/mixins.js';
import { Datetime } from 'vue-datetime';

import FinancesMiniTable from '../ModalFinancesTable';
import { financesInstance } from '@/axios/axios.js';

export default {
  async created() {
    if (this.$router.history.current.name === 'communityTransactions') {
      const virtualMembers = await financesInstance.get(
        `communities/${this.$store.getters.getActiveCommunity.id}/members`
      );
      for (let member of virtualMembers.data.members) {
        member.dataType = 'virtualMember';
      }
      this.setVirtualMembersList(virtualMembers.data.members);
    }
  },
  components: {
    ModelSelect,
    FinancesMiniTable,
    Datetime
  },
  mixins: [addSeparatorMixin, formatDateMixin],
  data() {
    return {
      loading: false,
      issueDate: '',
      total: 0,
      columns: [
        { key: 'member', label: 'Uplatilac', flex: 2 },
        { key: 'amount', label: 'Iznos', flex: 1 },
        { key: 'description', label: 'Opis', flex: 1 },
        { key: 'referenceNumber', label: 'Poziv na broj', flex: 1 }
      ],
      data: [],
      selectedMember: null,
      incomeAmount: null,
      incomeDescription: 'Uplata na račun',
      errorOccurred: false,
      payerOption: 'member',
      payerName: null
    };
  },
  computed: {
    ...mapState('finances', ['virtualMembers', 'transactions']),
    getSelectedUser() {
      if (!this.selectedMember) {
        return {
          div_description: '/',
          full_name: '/',
          balance: '/',
          id: '/'
        };
      } else {
        for (const member of this.virtualMembers.data) {
          if (member.id == this.selectedMember) {
            return member;
          }
        }
        return {
          div_description: '/',
          full_name: '/',
          balance: '/',
          id: '/'
        };
      }
    },
    options() {
      return this.virtualMembers.data.map(e => {
        return {
          value: e.id,
          text: `${e.full_name} - ${e.div_description}`
        };
      });
    }
  },
  watch: {
    payerOption: function() {
      if (this.payerOption === 'other') {
        this.selectedMember = null;
      }
      if (this.payerOption === 'member') {
        this.payerName = null;
      }
    }
  },
  methods: {
    ...mapMutations('modal', ['closeModal']),
    ...mapMutations('finances', ['setVirtualMembersList']),
    ...mapActions('finances', ['getTableData', 'getAccountDetails']),
    ...mapMutations('table', ['setTableData']),
    ...mapActions('table', ['getAllMembersForCommunityFinances']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    processKeyboardEvent(e) {
      if (e.key === 'Escape') {
        this.closeModal();
      } else if (e.key === 'Enter') {
        this.save();
      }
    },
    handleDatetimeInput(value) {
      if (value == '') {
        this.issueDate = new Date().toISOString();
      } else {
        this.issueDate = value;
      }
    },
    handleDatetimeClick() {
      this.$refs.datetime.$el.querySelector('.vdatetime-input').focus();
    },
    onChange() {
      this.$refs.amountInput.focus();
    },
    getTodayDateFormatted(date) {
      const dateObj = new Date(date);
      let todayDate = dateObj.toISOString();
      let dateYear = todayDate.split('T')[0];
      let dateHour = todayDate.split('T')[1].split('.')[0];
      return dateYear + ' ' + dateHour;
    },
    async save() {
      this.loading = true;
      this.errorOccurred = false;
      if (this.data.length == 0) {
        this.errorMessage = 'Morate dodati bar jednu uplatu';
        this.errorOccurred = true;
        this.loading = false;
        return;
      }
      // this.data.forEach(e => {
      //   e.description = 'Uplata na račun';
      // });

      financesInstance
        .post(
          `communities/${
            this.$store.getters.getActiveCommunity.community_id
          }/transactions`,
          this.data
        )
        .then(async () => {
          await this.getTableData({
            communityId: this.$store.getters.getActiveCommunity.id,
            tableName: 'transactions'
          });
          if (this.$router.history.current.name !== 'communityFinancesHome') {
            this.transactions.data.forEach(tx => {
              if (tx.amount < 0) {
                tx.div_description = 'Zajednica stanara';
              } else {
                if (tx.payer) {
                  tx.div_description = tx.payer;
                } else {
                  const divDesc = tx.div_description
                    ? ` (${tx.div_description})`
                    : '';
                  tx.div_description = tx.full_name + divDesc;
                }
              }
            });
            this.setTableData(this.transactions.data);
          } else {
            const virtualMembers = await this.getAllMembersForCommunityFinances(
              this.$store.getters.getActiveCommunity.id
            );
            this.setVirtualMembersList(virtualMembers);
            this.getAccountDetails();
          }
          this.loading = false;
          this.closeModal();
          this.showSuccessModal();
        })
        .catch(error => {
          console.log(error);
          this.loading = false;
          this.showFailModal();
        });
    },
    doesErrorExist() {
      return this.areFieldsEmpty() || this.numberFieldContainsLetters();
    },
    areFieldsEmpty() {
      if (
        this.incomeAmount === '' ||
        this.incomeAmount <= 0 ||
        !this.incomeDescription ||
        this.incomeDescription === ''
      ) {
        return true;
      }
      if (
        this.payerOption === 'member' &&
        (!this.selectedMember || this.selectedMember.text === '')
      ) {
        return true;
      }
      if (
        this.payerOption === 'other' &&
        (!this.payerName || this.payerName === '')
      ) {
        return true;
      }
      return false;
    },
    numberFieldContainsLetters() {
      // return this.incomeAmount.match(/[a-zA-Z]/g) == true;
      return false;
    },
    addIncome() {
      this.errorOccurred = false;
      if (this.doesErrorExist()) {
        this.errorMessage = 'Neispravan unos podataka';
        this.errorOccurred = true;
        return;
      }
      if (this.incomeDescription.length > 250) {
        this.errorMessage = 'Opis uplate ne može imati preko 250 karaktera';
        this.errorOccurred = true;
        return;
      }
      if (this.payerName && this.payerName.length > 250) {
        this.errorMessage = 'Uplatilac ne može imati preko 250 karaktera';
        this.errorOccurred = true;
        return;
      }
      let member = this.virtualMembers.data.find(
        e => e.id === this.selectedMember
      );

      let amount = parseFloat(
        parseFloat(this.incomeAmount.replace(/,/g, '')).toFixed(2)
      );
      if (this.payerOption === 'member' && member) {
        this.data.push({
          member: member.full_name,
          memberId: this.selectedMember,
          amount: amount,
          ordinal: this.data.length + 1,
          description: this.incomeDescription,
          referenceNumber: member.id,
          timestamp: this.getTodayDateFormatted(this.issueDate)
        });
      } else {
        if (this.payerOption === 'other') {
          this.data.push({
            member: this.payerName,
            memberId: null,
            amount: amount,
            ordinal: this.data.length + 1,
            description: this.incomeDescription,
            referenceNumber: '',
            timestamp: this.getTodayDateFormatted(this.issueDate),
            payer: this.payerName
          });
        } else {
          this.errorMessage = 'Neispravan unos podataka';
          this.errorOccurred = true;
          return;
        }
      }

      this.total += amount;
      this.total = parseFloat(this.total.toFixed(2));
      if (this.$refs.member) {
        this.$refs.member.$el.children[1].focus();
      }
    },
    removeMember(emitMember) {
      this.data.splice(emitMember.ordinal - 1, 1);
      let ordinal = 1;
      this.total -= emitMember.amount;
      this.total = parseFloat(this.total.toFixed(2));
      for (let member of this.data) {
        member.ordinal = ordinal++;
      }
    }
  },
  destroyed() {
    // document.removeEventListener('keydown', this.processKeyboardEvent);
  }
};
</script>
<style lang="scss">
.transaction-income {
  .body {
    padding: 2rem 0;
    height: 70vh;
    display: flex;
  }

  .radio-wrapper {
    display: flex;
  }
  .container {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 5px;
    cursor: pointer;
    font-size: 18px;
    color: #5f5f5f;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  /* Hide the browser's default radio button */
  .container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  /* Create a custom radio button */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: #eee;
    border-radius: 50%;
  }

  /* On mouse-over, add a grey background color */
  .container:hover input ~ .checkmark {
    background-color: #ccc;
  }

  /* When the radio button is checked, add a blue background */
  .container input:checked ~ .checkmark {
    background-color: var(--primary-color);
  }

  /* Create the indicator (the dot/circle - hidden when not checked) */
  .checkmark:after {
    content: '';
    position: absolute;
    display: none;
  }

  /* Show the indicator (dot/circle) when checked */
  .container input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the indicator (dot/circle) */
  .container .checkmark:after {
    top: 9px;
    left: 9px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: white;
  }

  .payer-member {
    margin-bottom: 1.8rem;
  }

  .add-income-header {
    justify-content: flex-start;
    span {
      margin-left: 8px;
    }
  }

  hr {
    margin-top: 0;
  }

  .input-wrapper {
    display: flex;
    width: 40%;
    max-width: 28%;
    position: relative;
    flex-direction: column;
    border-right: 1px solid #e9ecef;
    margin-right: 2rem;
    padding-right: 2rem;
    .user--mod {
      margin-bottom: 1.8rem;
      width: 100%;
      z-index: 5;
    }

    .member-info {
      h6 {
        margin-bottom: 2px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      small {
        display: inline-block;
        line-height: 1;
      }
      .member-info-title {
        font-size: 1.5rem;
        border-bottom: 2px solid var(--primary-color);
        display: inline-block;
        margin-bottom: 0.4rem;
      }
      .member-information {
        font-size: 1.5em !important;
      }
      .column-wrapper {
        display: flex;
        justify-content: space-between;
      }
      .column {
        justify-content: space-between;
        margin-bottom: 4px;
        width: 48%;
      }
    }

    .amount--mod {
      width: 100%;
      font-size: 10px;
      .input--amount {
        font-size: 1rem;
      }
    }

    .date--mod {
      margin-bottom: 1.8rem;
    }

    .btn--add {
      width: 100%;
      margin-bottom: 1.8rem;
    }

    .input-span {
      position: absolute;
      font-size: 1.5rem;
      color: rgb(95, 95, 95);
      top: 0.5rem;
      pointer-events: none;
      transition: 0.2s all;
      left: 1rem;
    }

    input[type='number'] {
      -moz-appearance: textfield;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }

    input {
      margin-right: 15px;
    }

    .input--:focus ~ .input-span--name,
    .input--name:not(:placeholder-shown) ~ .input-span--name {
      transform: scale(0.75) translateY(-50px) translateX(-30px);
      // opacity: 0;
    }

    .input--amount:focus ~ .input-span--amount,
    .input--amount:not(:placeholder-shown) ~ .input-span--amount {
      transform: scale(0.75) translateY(-50px) translateX(-30px);
    }

    .datetime-mask {
      position: relative;

      .calendar--mod {
        position: absolute;
        right: 10px;
        bottom: 12px;
        color: #989899;
      }
    }

    .desc {
      font-size: 18px;
      color: rgb(95, 95, 95);
      margin-bottom: 0;
    }

    .datetime-mask:hover {
      cursor: text;
    }

    .vdatetime-input {
      opacity: 0;
      position: absolute;
    }

    .relative {
      position: relative;
    }
  }

  .data-wrapper {
    width: 100%;
    position: relative;
    height: 100%;

    .members-table {
      height: calc(100% - 30px);
    }
    .total {
      font-weight: 900;
      bottom: 0;
      position: absolute;
      right: 0;
    }
  }
}

.footer.add-income {
  width: 100%;

  .error {
    color: red;
    float: left;
    margin: 0 auto;
    margin-left: 1rem;
    display: flex;
    align-items: center;
  }

  .buttons {
    float: right;
    height: 38px;
    button:disabled {
      background-color: var(--primary-color-lighten);
      cursor: not-allowed;
    }

    button {
      height: 35px;
      min-width: 80px;
      width: 80px;
      text-align: center;
    }
  }
}
</style>
